import { useQuery } from '@tanstack/react-query';
import {
  GetLinearBuyingAssignmentsResponse,
  UpdateLinearBuyingAssignmentsParams
} from '@blisspointmedia/bpm-types/dist/LinearAssignments';
import { awaitJSON, LinearBuyingLambdaFetch } from '@src/utils/fetch-utils';

export const useLinearBuyingAssignments = (): ReturnType<
  typeof useQuery<GetLinearBuyingAssignmentsResponse>
> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['linearBuyingAssignments'],
    queryFn: async (): Promise<GetLinearBuyingAssignmentsResponse> =>
      awaitJSON<GetLinearBuyingAssignmentsResponse>(
        await LinearBuyingLambdaFetch('/buying_assignments')
      )
  });

export const saveLinearBuyingAssignments = async (
  rows: UpdateLinearBuyingAssignmentsParams[]
): Promise<void> => {
  await LinearBuyingLambdaFetch<UpdateLinearBuyingAssignmentsParams[]>('/buying_assignments', {
    method: 'POST',
    body: rows
  });
};
